import React, { useState, useEffect } from "react";
import withApi from "../../higherOrderComponents/withApi";
import ReactSelect from "react-select";

export const CrawlFilters = withApi(({ api, productId }) => {
  const [integrationId, setIntegrationId] = useState(null);
  const [data, setData] = useState(null);
  const [editing, setEdit] = useState(null);
  const [editedFrom, setFrom] = useState(null);
  const [editedTo, setTo] = useState(null);
  const [editedPriority, setPriority] = useState(null);
  const [editedDuration, setDuration] = useState(null);
  const [editedDays, setDays] = useState(null);
  const [editedStartDate, setStartDate] = useState(null);
  const [editedEndDate, setEndDate] = useState(null);
  const [editedDaysFromTodayFrom, setDaysFromTodayFrom] = useState(null);
  const [editedDaysFromTodayTo, setDaysFromTodayTo] = useState(null);
  const [editedResourceMatch, setResourceMatch] = useState(null);
  const [editedInclude, setInclude] = useState(null);

  const options = [
    { value: true, label: "true" },
    { value: false, label: "false" },
  ];

  useEffect(() => {
    async function loadFromApi() {
        const integration = await api.integrations.getIntegrationByProductId(
            productId
          );
          setIntegrationId(integration.Id);
          var response = await api.integrations.getCrawlFilters(integration.Id);
    
          setData(response);
    }

    if (!data) {
      loadFromApi();
    }
  });

  const formatDate = (date) => {
    if (date == null) {
      return null;
    }
    const parsedDate = new Date(date);

    const day = String(parsedDate.getDate()).padStart(2, '0');
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const year = parsedDate.getFullYear();
    const hour = String(parsedDate.getHours()).padStart(2, '0');
    const minute = String(parsedDate.getMinutes()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day} ${hour}:${minute}`;

    return formattedDate;
  }

  if (data === null) {
    return <React.Fragment>Loading...</React.Fragment>;
  }

  return (
    <React.Fragment>
    <h3>Crawl Filters</h3>
      <button
        type="button"
        className="button button-color-primary button-shrink-limited"
        onClick={async () => {
          await api.integrations.addFilter({
            from: null,
            to: null,
            priority: 0,
            durationInSeconds: null,
            dayOfWeekFlag: null,
            resourceMatch: null,
            startDate: null,
            endDate: null,
            daysFromTodayFrom: null,
            daysFromTodayTo: null,
            include: false,
            integrationId: integrationId
          });
          const loadedData = await api.integrations.getCrawlFilters(integrationId);
          setData(loadedData);
        }}
      >
        New
      </button>

      <br></br>
      <br></br>

      <table className="data-lists component-data-table cell-content-align-top data-table-no-results">
        <tr style={{ backgroundColor: "#5e5e5e", color: "#f1f1f3" }}>
          <td>From</td>
          <td>To</td>
          <td>Priority</td>
          <td>Duration In Minutes</td>
          <td>Days Of Week</td>
          <td>Resource Match</td>
          <td>Start Date</td>
          <td>End Date</td>
          <td>Days From Today From</td>
          <td>Days From Today To</td>
          <td>Include</td>
          <td></td>
          <td></td>
        </tr>
        {data.map((whole) => {
          const {
            id,
            from,
            to,
            priority,
            durationInSeconds,
            dayOfWeekFlag,
            daysFromTodayFrom,
            daysFromTodayTo,
            resourceMatch,
            startDate,
            endDate,
            include
          } = whole;

          if (editing == id) {
            return (
              <tr>
                <td>
                  <input
                    style={{ width: "100px" }}
                    type="text"
                    value={editedFrom}
                    onChange={(e) => {
                        console.log(e.target.value);
                        setFrom(e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <input
                    style={{ width: "100px" }}
                    type="text"
                    value={editedTo}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setTo(e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <input
                    style={{ width: "50px" }}
                    type="number"
                    value={editedPriority}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setPriority(e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <input
                    style={{ width: "80px" }}
                    type="number"
                    value={editedDuration}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setDuration(e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <span>
                    {["m", "t", "w", "t", "f", "s", "s"].map((day, index) => (
                      <span
                        onClick={() => {
                          setDays(editedDays ^ Math.pow(2, index));
                        }}
                        style={{
                          fontWeight:
                            editedDays & Math.pow(2, index) ? "800" : "100",
                          marginRight: "5px",
                          fontSize: "20px",
                          cursor: "pointer",
                        }}
                      >
                        {day}
                      </span>
                    ))}
                  </span>
                </td>
                <td>
                  <input
                    type="text"
                    value={editedResourceMatch}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setResourceMatch(e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <input
                    type="datetime-local"
                    value={editedStartDate}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setStartDate(e.target.value == "" ? null : e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <input
                    type="datetime-local"
                    value={editedEndDate}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setEndDate(e.target.value == "" ? null : e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <input
                    style={{ width: "50px" }}
                    type="number"
                    value={editedDaysFromTodayFrom}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setDaysFromTodayFrom(e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <input
                    style={{ width: "50px" }}
                    type="number"
                    value={editedDaysFromTodayTo}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setDaysFromTodayTo(e.target.value);
                    }}
                  ></input>
                </td>
                <td>
                  <ReactSelect
                  className="react-select-filters-section"
                  classNamePrefix="react-select-filters-section-prefix"
                  value={
                    options.filter(
                      (x) => x.value === editedInclude
                    ) || ""
                  }
                  onChange={(selection) =>
                  { console.log(selection.value)
                    setInclude(selection.value)}
                  }
                  options={options}
                ></ReactSelect>
                </td>
                <td
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setEdit(null);
                  }}
                >
                  Cancel
                </td>
                <td
                  style={{ cursor: "pointer" }}
                  onClick={async () => {
                    await api.integrations.editFilter(
                      Object.assign(whole, {
                        from: editedFrom,
                        to: editedTo,
                        priority: editedPriority,
                        durationInSeconds: editedDuration * 60 || undefined,
                        dayOfWeekFlag: editedDays,
                        resourceMatch: editedResourceMatch,
                        startDate: editedStartDate,
                        endDate: editedEndDate,
                        daysFromTodayFrom: editedDaysFromTodayFrom,
                        daysFromTodayTo : editedDaysFromTodayTo,
                        include: editedInclude
                      })
                    );
                    const loadedData = await api.integrations.getCrawlFilters(
                      integrationId
                    );
                    setEdit(null);
                    setData(loadedData);
                  }}
                >
                  Save
                </td>
              </tr>
            );
          }

          return (
            <tr>
              <td>{from}</td>
              <td>{to}</td>
              <td>{priority}</td>
              <td>{durationInSeconds / 60 || ""}</td>
              <td>
                <span>
                  {dayOfWeekFlag
                    ? ["m", "t", "w", "t", "f", "s", "s"].map((day, index) => (
                        <span
                          style={{
                            fontWeight:
                              dayOfWeekFlag & Math.pow(2, index)
                                ? "800"
                                : "100",
                            marginRight: "5px",
                            fontSize: "20px",
                          }}
                        >
                          {day}
                        </span>
                      ))
                    : ""}
                </span>
              </td>
              <td>{resourceMatch}</td>
              <td>{formatDate(startDate)}</td>
              <td>{formatDate(endDate)}</td>
              <td>{daysFromTodayFrom}</td>
              <td>{daysFromTodayTo}</td>
              <td>{include.toString()}</td>
              <td
                style={{ cursor: "pointer" }}
                onClick={async () => {
                  const result = confirm("Are you sure to delete this filter?");
                  if (!result) {
                    return;
                  }
                  await api.integrations.deleteFilter(id);
                  const loadedData = await api.integrations.getCrawlFilters(
                    integrationId
                  );
                  setData(loadedData);
                }}
              >
                Delete
              </td>
              <td
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setEdit(id);
                  setFrom(from);
                  setTo(to);
                  setPriority(priority);
                  setDuration(durationInSeconds/60);
                  setDays(dayOfWeekFlag);
                  setResourceMatch(resourceMatch);
                  setStartDate(startDate);
                  setEndDate(endDate);
                  setInclude(include);
                }}
              >
                Edit
              </td>
            </tr>
          );
        })}
      </table>
    </React.Fragment>
  );
});
